'use client';

import React from 'react';
import TrailingLink from '@/components/atoms/TrailingLink';
import styles from './ServiceCTA.module.scss';

interface ServiceCTAProps {
  title: string;
  description: string;
  ctaText?: string;
  ctaHref?: string;
  className?: string;
}

export function ServiceCTA({
  title,
  description,
  ctaText = '無料相談を申し込む',
  ctaHref = '/contact',
  className
}: ServiceCTAProps) {
  return (
    <section className={`${styles.cta} ${className || ''}`}>
      <div className={styles.ctaContent}>
        <h2 className={styles.ctaTitle}>{title}</h2>
        <p className={styles.ctaDescription}>{description}</p>
        <TrailingLink href={ctaHref} className={styles.ctaButton}>
          {ctaText}
        </TrailingLink>
      </div>
    </section>
  );
}

export default ServiceCTA;